import React, { useState } from "react";
import "./FeedbackSection.css";

const FeedbackSection = ({ serviceId }) => {
    // Sample Data (Replace with API fetch)
    const feedbackData = {
        averageRating: 4.85,
        totalReviews: 80000,
        starDistribution: {
            5: 76000,
            4: 2000,
            3: 658,
            2: 481,
            1: 2000,
        },
        reviews: [
            {
                name: "Akash",
                date: "Jan 29, 2025",
                service: "360 AC Protect, Heater",
                rating: 5,
                comment: "Services is Great",
            },
            {
                name: "Mr. Unknown",
                date: "Jan 30, 2025",
                service: "360 AC Protect",
                rating: 5,
                comment: "Ekach Number!",
            },
            {
                name: "John Doe",
                date: "Feb 1, 2025",
                service: "Deep Cleaning",
                rating: 4,
                comment: "Very professional service!",
            },
            {
                name: "Emily Smith",
                date: "Feb 2, 2025",
                service: "Sofa Cleaning",
                rating: 5,
                comment: "Great results, highly recommend!",
            },
            {
                name: "Rahul",
                date: "Feb 3, 2025",
                service: "AC Servicing",
                rating: 3,
                comment: "Okay experience, but can improve.",
            },
        ],
    };

    const [visibleReviews, setVisibleReviews] = useState(2);

    // const showMoreReviews = () => {
    //     setVisibleReviews((prev) => prev + 3); 
    // };

    return (
        <div className="feedback-container">
            <h2>Reviews</h2>
            <div className="overall-rating">
                <h2>★ {feedbackData.averageRating}</h2>
                <p>{feedbackData.totalReviews.toLocaleString()} reviews</p>
            </div>

            {/* Star Distribution */}
            <div className="star-distribution">
                {Object.entries(feedbackData.starDistribution).map(([stars, count]) => (
                    <div key={stars} className="star-row">
                        <span>★ {stars}</span>
                        <div className="bar">
                            <div className="fill" style={{ width: `${(count / feedbackData.totalReviews) * 100}%` }}></div>
                        </div>
                        <span>{count.toLocaleString()}</span>
                    </div>
                ))}
            </div>

            <div className="review-filters">
                <button className="filter-btn">Positive</button>
                <button className="filter-btn">Negative</button>
                <button className="filter-btn">Frequent users</button>
                <span className="filter-link">Filter</span>
            </div>

            {/* Reviews List */}
            <div className="reviews-list">
                {feedbackData.reviews.slice(0, visibleReviews).map((review, index) => (
                    <div key={index} className="review-card">
                        <div className="review-header">
                            <h4>{review.name}</h4>
                            <span className="review-rating">★ {review.rating}</span>
                        </div>
                        <p className="review-meta">{review.date} • For {review.service}</p>
                        <p className="review-comment">{review.comment}</p>
                    </div>
                ))}
            </div>

            {/* Show More Button */}
            {visibleReviews < feedbackData.reviews.length && (
                <div className="show-more-container">
                    <button className="show-more-btn">
                        Show More Reviews
                    </button>
                </div>
            )}
        </div>
    );
};

export default FeedbackSection;
